import React from "react";
import { Button, VStack } from "@chakra-ui/react";

import { ButtonModal } from "@components";
import { DocumentActions } from "@hooks";

type ScrapAuxComponentModalProps = {
  updateComponent: DocumentActions["update"];
};

export function ScrapAuxiliaryComponentModal({
  updateComponent,
}: ScrapAuxComponentModalProps) {
  const submitScrap = React.useCallback(
    () => updateComponent({ status: "DO_NOT_USE" }),
    [updateComponent],
  );
  return (
    <ButtonModal
      title="Are you sure?"
      label="Scrap"
      colorScheme="danger"
      size="sm"
    >
      <VStack width="100%">
        <Button colorScheme="red" onClick={submitScrap} margin="auto">
          Yes
        </Button>
      </VStack>
    </ButtonModal>
  );
}
